import styled from 'styled-components';
import { screenReaderOnlyTextStyles } from '#/shared/components/Accessibility';

export const Fieldset = styled.fieldset`
  /* removes default border from fieldset */
  border: none;
`;

/*
 * this CSS intentionally duplicated from ScreenReaderText in order to not break fieldset/legend relationship
 * see https://adrianroselli.com/2022/07/use-legend-and-fieldset.html
 */
export const Legend = styled.legend`
  ${screenReaderOnlyTextStyles}
`;

/*
 * Even though HeadingTag is not visible and has no styles, we include it as a styled component
 * so we can take advantage of the `as` prop for times when we need to vary the heading level
 */
export const HeadingTag = styled.h2``;

export const VisibleHeading = styled.div`
  color: ${props => props.theme.checkboxLabelText};
  font-size: 1.5rem;
  margin-bottom: 0.5em;
`;
